var $ = jQuery.noConflict();
$(document).ready(function() {
	
	// alert("jQuery added successfully!");
  
	/**
	 * Animates the main menu drop down effect.
	 */
	$('.main-nav-menu .parent').removeClass("parent");
	$('.main-nav-item').hover(		
		function(){
			$(this).children('.main-nav-sub-menu').stop(true, true).delay(100).slideDown(240);
		},
		function(){
			$(this).children('.main-nav-sub-menu').stop(true, true).slideUp(240);
		}
	);
	
	/**
	 * Adds keyboard focus to the main menu.
	 */
	$('nav li a').focus(function() {
		$(this).siblings('nav li ul').addClass('focused');
	}).blur(function() {
		$(this).siblings('nav li ul').removeClass('focused');
	});
	$('nav li a').focus(function() {
		$(this).parents('nav li ul').addClass('focused');
	}).blur(function() {
		$(this).parents('nav li ul').removeClass('focused');
	});
	
});

/**
 * Sets the scrollbar width.
 */
function _calculateScrollbarWidth() {
  document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) - 1 + "px");
}
// recalculate on resize
window.addEventListener('resize', _calculateScrollbarWidth, false);
// recalculate on dom load
document.addEventListener('DOMContentLoaded', _calculateScrollbarWidth, false); 
// recalculate on load (assets loaded as well)
window.addEventListener('load', _calculateScrollbarWidth);
